import React from "react";

import { getDOY, _common } from "../../common";
const common = _common;

function zfill(num: number, len: number) {
  return (Array(len).join("0") + num).slice(-len);
}

export default function DayHeader(props: { date: Date }) {
  const { date } = props;

  var iWeekday = date.getDay();
  var day = zfill(date.getDate(), 2) + "." + zfill(date.getMonth() + 1, 2) + "." + date.getFullYear();

  var weekDay = common.days[iWeekday];

  const dayOffset = getDOY(date) - getDOY(new Date());

  var relDay = "";

  switch (dayOffset) {
    case 0:
      relDay = "Heute ";
      break;

    case 1:
      relDay = "Morgen ";
      break;

    case 2:
      relDay = "Übermorgen ";
      break;
  }

  if (common.anzeigeTafelMode) {
    relDay = "";
  }

  const time = new Date();
  const sTime = time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const showWindowWidth = false;

  return (
    <div
      id="dayHeader"
      style={{
        position: "relative",
        width: "100%",
        height: common.anzeigeTafelMode ? undefined : common.topSpacingPerDay,
        paddingTop: common.anzeigeTafelMode ? "10px" : undefined,
        backgroundColor: "lightgray",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <b>{relDay}</b> {weekDay}
      <div
        style={{
          position: "absolute",
          left: "10px",
          top: "10px",
        }}
      >
        {showWindowWidth && <span>w={window.innerWidth}</span>}
        <span style={{ color: "grey", fontSize: "0.7em" }}>{day}</span>
      </div>
      <div
        style={{
          position: "absolute",
          right: "10px",
          top: "10px",
        }}
      >
        <span style={{ fontSize: "0.7em" }}>{sTime}</span>
      </div>
    </div>
  );
}
